module.exports = __webpack_public_path__ + "static/media/fans.2ecf5b49.png";